import React from 'react';
import Main from '../components/Main';
import Layout from '../../shared/components/Layout';

const Top: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Main />
      </Layout>
    </React.Fragment>
  );
};

export default Top;